import { vehicleOptionsSchema } from './vehicle-options.schema';
import { routingOptionsSchema } from './routing-options.schema';
import { coPilotOptionsSchema } from './copilot-options.schema';
import { unitsOfMeasurementSchema } from '../../../schemas/units-of-measurement.schema';
import { vehicleTypeSchema } from '../../../schemas/vehicle-type.schema';
import { z } from 'zod/v4';

export const routingProfileSchema = z.object({
  routingProfileId: z.number(),
  routingProfileTemplateId: z.number().nullable().optional(),
  name: z.string().min(1),
  isAccountDefault: z.boolean(),
  vehicleType: vehicleTypeSchema,
  units: unitsOfMeasurementSchema,
  vehicleOptions: vehicleOptionsSchema.optional(),
  routingOptions: routingOptionsSchema,
  copilotOptions: coPilotOptionsSchema.optional(),
  vehicleGroups: z
    .array(
      z.object({
        vehicleGroupId: z.number().optional(),
        vehicleGroupName: z.string().optional(),
      })
    )
    .optional(),
});

export type RoutingProfile = z.infer<typeof routingProfileSchema>;
